module.exports = __webpack_public_path__ + "static/media/banner.b8903e64.jpg";